import {WrapperBlockSider} from "../components/WrapperBlockSider";
import React, {useContext} from "react";
import OrganizationContainerContext from "../OrganizationContainerContext";
import _ from "lodash";
import {BsFillCalendar2DateFill, BsShieldLockFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getTitle from "../../../../helpers/getTitle";
import {renderIf} from "../../../Shared";
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import useTranslate from "../../../../modules/local/useTranslate";
import {exam_getExaminations_Api} from "../../../../apis";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import {bindQueryParams} from "../../functions/routerHelper";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ExamOutlineSvg} from "../../../../components/Svgs/ExamSvg";
import {ItemInfoWithIcon} from "../../../../components/common/ItemInfoWithIcon";

export const OrganizationExaminations = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const examinations = _.get(organization, 'examinations', [])

    return (
        <CustomLazyPaginationWrapper
            auto={false}
            sample={2}
            apiInfo={exam_getExaminations_Api}
            renderItem={(e, i) => {
                const {time_open, time_close} = e ?? {}
                return (
                    <div key={i} className="px-3 py-2 background-50 hover:scale-2xs hover:shadow-md rounded-xl">
                        {_.get(e, 'privacy') === 2 && (
                            <BsShieldLockFill
                                size={20}
                                className="absolute text-blue-700 opacity-80"
                                style={{top: '0.5rem', right: '0.5rem'}}
                            />
                        )}
                        <Link
                            to={getLinkToDetail(e)}
                            className="font-bold text-base text-color-000 no-underline max-lines-1 mb-1">
                            {getTitle(e)}
                        </Link>
                        {renderIf(
                            _.some([time_open, time_close]),
                            <ItemInfoWithIcon
                                icon={<BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>}
                                value={renderFromToTime(time_open, time_close)}
                                className="text-xs italic"
                            />
                        )}
                        <div className="text-right font-semibold text-xs md:text-xs italic">
                            {_.get(e, 'is_expired') === true ? (
                                <span className="text-red-600">{t('close')}</span>
                            ) : dayjs(_.get(e, 'time_open')).isAfter(dayjs()) ? (
                                <span className="text-green-700">{t('upcoming')}</span>
                            ) : (
                                <span className="text-blue-700">{t('opening')}</span>
                            )}
                        </div>
                    </div>
                )
            }}
            renderLoading={renderPagingLoading}
            id={[exam_getExaminations_Api.path, organization?.id, 1].join("/")}
            query={bindQueryParams([{id: organization?.id}, {type: 'organization'}])}
            values={{status: 1}}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <WrapperBlockSider
                        title="examinations" titleColor="text-indigo-700" expanded={!isLg}
                        borderLeft={isLg}
                        borderTop={!isLg}
                        icon={<ExamOutlineSvg size={18} className="text-indigo-400"/>}>
                        <div className="flex flex-col gap-4">
                            {children}
                        </div>
                    </WrapperBlockSider>
                )
            }}
        />
    )
}